import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';

import { BrowserRouter } from 'react-router-dom';
import { useApiProvider, ApiProvider } from './providers/ApiProvider.js';
import { useSidebarProvider, SidebarProvider } from './providers/SidebarProvider.js';
import { useLeagueTypeProvider, LeagueTypeProvider } from './providers/LeagueTypeProvider.js';


const root = ReactDOM.createRoot(document.getElementById('root'));
var rootDom = document.getElementById('root');
rootDom.setAttribute('style', 'height:100%');
root.render(
  <React.StrictMode>
    <BrowserRouter>
    {/* Providers/context*/}
    <ApiProvider>
    <SidebarProvider>
    <LeagueTypeProvider>

      {/* Main application*/}
      <App />
      
    </LeagueTypeProvider>
    </SidebarProvider>
    </ApiProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
